<div id="user-settings-ai-coworker" class="settings-panel" [class.mobile]="isMobile">
  <div class="head">
    <span class="material-icons go-back" (click)="goBack.emit()"> arrow_back </span>
    <div class="description">
      <div class="title">{{ PANELS.AI_COWORKER.name }}</div>
      <div class="subtitle">{{ PANELS.AI_COWORKER.description }}</div>
    </div>
    <span class="material-icons close" (click)="goBack.emit()"> close </span>
  </div>
  <div class="sub-head" *ngIf="isMobile">
    {{ PANELS.AI_COWORKER.description }}
  </div>

  <div class="panel-body">
    <mat-tab-group color="primary" class="ai-coworker-tabs" [disableRipple]="true">
      <mat-tab [label]="'Settings' | translate">
        <div class="tab-section">
          <div class="loading" *ngIf="isLoading">{{ 'Loading…' | translate }}</div>

          <p class="notice" *ngIf="!isLoading && loadFailed" role="alert">
            {{ 'These settings could not be loaded. Close this panel and try again.' | translate }}
          </p>

          <p class="notice" *ngIf="!isLoading && !loadFailed && !agentEnabled">
            {{
              'The AI coworker isn’t turned on for your organization yet. Once it is, you can choose how it joins your calls here.'
                | translate
            }}
          </p>

          <div class="section-group" *ngIf="!isLoading && !loadFailed && agentEnabled">
            <h4 class="section-title">{{ 'Calls' | translate }}</h4>
            <form class="toggle-group" [formGroup]="form">
              <app-user-settings-permissions-toggle
                [options]="{
                  setting: 'autoJoinCalls',
                  titleText: 'Join calls automatically' | translate,
                  activeText:
                    'When a call starts in one of your organization’s spaces, the AI coworker joins it. Anyone in the call can ask it to leave, and bring it back, from the AI panel.'
                    | translate,
                  inactiveText:
                    'The AI coworker joins a call only when someone in it asks it to, from the AI panel.'
                    | translate
                }"
              ></app-user-settings-permissions-toggle>
            </form>
          </div>
        </div>
      </mat-tab>
      <mat-tab [label]="'Connectors' | translate">
        <ng-template matTabContent>
          <app-user-settings-connectors
            [embedded]="true"
            [isMobile]="isMobile"
            [PANELS]="PANELS"
          ></app-user-settings-connectors>
        </ng-template>
      </mat-tab>
      <mat-tab [label]="'Usage' | translate">
        <ng-template matTabContent>
          <app-user-settings-usage
            [embedded]="true"
            [isMobile]="isMobile"
            [PANELS]="PANELS"
          ></app-user-settings-usage>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
